var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10h14a2 2 0 0 1 2 2v2H3v-2a2 2 0 0 1 2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14v6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10V7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10V7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBench);
export default __webpack_public_path__ + "static/media/bench.fba555b64a24270a04d43597155076f3.svg";
export { ForwardRef as ReactComponent };